export default {
    profile: 'Profil',
    home:'Accueil',
    booking_history:'Réservation',
    logout: 'Déconnexion',
    about_us:'A Propos de Nous',
    booking_cancelled:'La réservation est annulée. ID : ',
    no_cars:'Aucune voiture disponible.',
    no_route:'Aucun itinéraire trouvé.',
    firstname:'Prénom',
    lastname:'Nom',
    email:'Email',
    phone:'Numéro Téléphone',
    password:'Mot de passe',
    otp:'OTP',
    profile_updated:'Profil mis à jour.',
    proper_email:'Veuillez saisir correctement votre e-mail.',
    submit:'Mettre à jour',
    booking_title:'Mes réservations',
    booking_id:'N° Réservation',
    booking_date: 'Date Réservation',
    car_type: 'Type de voiture',
    pickup_address :'Adresse Ramassage',
    drop_address: 'Adresse Dépôt',
    booking_status: 'Statut Réservation',
    trip_cost:'Prix course',
    payment_status:'Statut paiement',
    cancel_booking:'Annulation',
    select_car:'Type de voiture',
    number_phone: 'Téléphone client',
    select_booking_type:'Sélectionnez le type de réservation',
    book_now: 'Réservation',
    book_later: 'Plus tard',
    book: 'Réserver',
    select_proper:'Veuillez sélectionner correctement.',
    must_login:'Veuillez vous connecter pour réserver',
    pickup_location:'Adresse de ramassage',
    drop_location:'Adresse de dépôt',
    booking_success:'Réservation réussie. ID de réservation :',
    select_reason: 'Sélectionnez le motif d\'annulation',
    cancel :'Annuler',
    ok:'OK',
    myaccount: 'Mon Compte',
    login_signup: 'Se connecter / S\'inscrire',
    login_success:'Connexion réussie. Merci de finaliser l\'inscription.',
    login_validate_error:'L\'email ou le mot de passe n\'est pas correct.',
    otp_validate_error:'OTP is not valid',
    reset_pass_msg:'Lien de réinitialisation du mot de passe envoyé par e-mail.',
    signin:'Se connecter',
    login:'Se connecter',
    register:'S\'inscrire',
    get_otp:'Obtenir code',
    verify_otp:'Vérifier code',
    complete_registration:'Enregistrement complet',
    forgot_pass_title:'Mot de passe oublié ?',
    forgot_pass_description:'Merci de renseigner votre adresse mail. Un lien pour réinitialiser votre mot de passe vous sera envoyé dans votre messagerie.',
    reset_password:'Réinitialiser le mot de passe',
    email_tab:'Par e-mail',
    phone_tab:'Par téléphone',
    booking_date_time:'Heure des données de réservation',
    past_booking_error:'Aucun chauffeur disponible pour cette horaire. Merci de faire la réservation 1h avant le voyage.',
    booking_taken:'La réservation est prise. Le chauffeur sera affecté dans les 15 minutes avant l\'heure de votre réservation. Votre ID de réservation est:',
    settings_error: 'Impossible de récupérer les paramètres.',
    estimate:'Estimation tarifaire',
    auth_error:'Alerte d\'authentification',
    email_verify_message:'Veuillez vérifier votre boite e-mail pour valider votre inscription.'
}